import { Flex, Skeleton } from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import {
  CallDetailsRow,
  CallDetailsRowItem,
} from '~/pages/Calls/CallDetails/CallDetailsRow'
import { HoldAndPauseTimeSection } from '~/pages/Calls/CallDetails/sections/HoldAndPauseTimeSection'
import { InterruptionsSection } from '~/pages/Calls/CallDetails/sections/InterruptionsSection'
import { OfficeTalkSpeedSection } from '~/pages/Calls/CallDetails/sections/OfficeTalkSpeedSection'
import { OfficeTalkTimeSection } from '~/pages/Calls/CallDetails/sections/OfficeTalkTimeSection'
import { SentimentByQuarterSection } from '~/pages/Calls/CallDetails/sections/SentimentByQuarterSection'
import { CallTranscript } from '~/types'

interface CallDetailsStatsTabProps {
  transcript?: CallTranscript
  isLoadingTranscripts: boolean
}

export const CallDetailsStatsTab = ({
  transcript,
  isLoadingTranscripts,
}: CallDetailsStatsTabProps) => {
  const { t } = useTranslation()

  return (
    <Flex flexDirection="column" gap="1.25rem" width="100%">
      {isLoadingTranscripts ? (
        <>
          <Skeleton h="14rem" />
          <Flex w="full" h="8rem" gap="1.25rem">
            <Skeleton flexGrow="1" />
            <Skeleton flexGrow="1" />
          </Flex>
          <Flex w="full" h="8rem" gap="1.25rem">
            <Skeleton flexGrow="1" />
            <Skeleton flexGrow="1" />
          </Flex>
        </>
      ) : transcript ? (
        <>
          <CallDetailsRow>
            <CallDetailsRowItem>
              {transcript && (
                <SentimentByQuarterSection transcript={transcript} />
              )}
            </CallDetailsRowItem>
          </CallDetailsRow>
          <CallDetailsRow>
            <CallDetailsRowItem>
              <HoldAndPauseTimeSection transcript={transcript} />
            </CallDetailsRowItem>
            <CallDetailsRowItem>
              <OfficeTalkTimeSection transcript={transcript} />
            </CallDetailsRowItem>
          </CallDetailsRow>
          <CallDetailsRow>
            <CallDetailsRowItem>
              <OfficeTalkSpeedSection transcript={transcript} />
            </CallDetailsRowItem>
            <CallDetailsRowItem>
              <InterruptionsSection transcript={transcript} />
            </CallDetailsRowItem>
          </CallDetailsRow>
        </>
      ) : (
        <CallDetailsRow>
          <CallDetailsRowItem>
            {t('callDetails.statisticsNotAvailable')}
          </CallDetailsRowItem>
        </CallDetailsRow>
      )}
    </Flex>
  )
}
